import { useEffect, useState } from 'react'
import { usePwaInstallStore, isIos, isDesktopSafari, isStandalone } from '../../stores/pwaInstallStore'
import { InstallAppModal } from './InstallAppModal'

const SEEN_KEY = 'snapshot-install-prompt-seen'

// ponytail: browsers require a real click to call prompt() (no fully silent auto-install),
// so we surface our own banner immediately on first visit and let the user's click on it
// satisfy the gesture requirement. The same modal is reachable again later from Settings.
export function InstallPrompt() {
  const deferredPrompt = usePwaInstallStore((s) => s.deferredPrompt)
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(SEEN_KEY)) return
    if (isIos() || isDesktopSafari()) {
      setShow(true)
      return
    }
  }, [])

  useEffect(() => {
    if (deferredPrompt && !isStandalone() && !localStorage.getItem(SEEN_KEY)) {
      setShow(true)
    }
  }, [deferredPrompt])

  const close = () => {
    localStorage.setItem(SEEN_KEY, '1')
    setShow(false)
  }

  if (!show) return null
  return <InstallAppModal onClose={close} />
}
